import { render, staticRenderFns } from "./conversionBlock.vue?vue&type=template&id=3797623a&"
import script from "./conversionBlock.vue?vue&type=script&lang=js&"
export * from "./conversionBlock.vue?vue&type=script&lang=js&"
import style0 from "./conversionBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports